// import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'stock_adjust',
    component: () => import('./List.vue'),
  },
  {
    path: 'add',
    name: 'stock_adjust_new',
    component: () => import('./New'),
  },
  // {
  //   path: ':id/edit',
  //   name: 'invoice_application_edit',
  //   component: () => import('./Edit'),
  //   props: true,
  // },
]
